function dateFormat (inputDate) {
  const year = inputDate ? inputDate.slice(0,4) : ''
  const month = inputDate ? inputDate.slice(5,7) : ''
  const day = inputDate ? inputDate.slice(-2) : ''
  return day + '.' + month + '.' + year 
}
export default dateFormat